<template>
    <div class="page">
        <div class="wrap1">
            <img
                class="label3"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc2873af9ca5fe49933bdf83bacfabf622ff0a0cfdc58e0c0c3e17e226463820b"
            />
            <span class="word2">核销成功</span>
            <div class="couponList">
                <div>
                 <span>优惠券</span>
                <span>{{ couponData.quoteName }}</span>
                </div>
                <div>
                    <span>有效期</span>
                    <span>{{ validityPeriod }}</span>
                </div>
            </div>
         </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            quoteName: '',
            startTime: '',
            endTime: '',
            longTermStatus: null,
            validityPeriod: '',
            couponData: {}
        }
    },
    mounted(){
        try {
            const writeOffData = localStorage.getItem('writeOffData');
            if (writeOffData) {
                this.couponData = JSON.parse(writeOffData);

                // 处理有效期显示
                if(this.couponData.longTermStatus == 10) {
                    this.validityPeriod = '长期';
                } else if(this.couponData.startTime && this.couponData.endTime) {
                    this.validityPeriod = this.formatDate(this.couponData.startTime) + '-' + this.formatDate(this.couponData.endTime);
                }
            }
        } catch (error) {
            console.error('获取核销数据失败', error);
        }
    },
    methods: {
        formatDate(dateStr) {
            const parts = dateStr.split('-');
            if (parts.length === 3) {
                return `${parts[0]}年${parts[1]}月${parts[2]}日`;
            }
            return dateStr;
        }
    }
}
</script>

<style lang="less" scoped>
.page {
    background-color: #F7F8FC;
    height:100vh;
    padding:20px;
}
.wrap1{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding:20px;
    padding-top:80px;
    width:80%;
    margin:0 auto;
    border-radius: 10px;
}
.word2{
    margin:20px 0;
}
.couponList{
   background-color: #F7F8FC;
   padding: 15px;
   border-radius: 10px;
   div {
       display: flex;
       margin-bottom: 12px;
       font-size: 14px;
       line-height: 1.5;

       &:last-child {
           margin-bottom: 0;
       }

       span:first-child {
           min-width: 70px;
           color: #666;
           flex-shrink: 0;
       }

       span:last-child {
           color: #333;
           flex: 1;
           word-break: break-all;
       }
   }
}
</style>
